import {
    AdaptadorAgrupamentoRelatorio,
    derivarGroupingModel,
    podeExpandirGrupoTerminal,
} from '../PontoDiario/contrato-agrupamento'
import { explodirLinhas, LinhaExplodidaAjuste } from './explodir-linhas'
import {
    Ajuste,
    CAMPO_POR_NIVEL,
    LABEL_NIVEL,
    NivelAjuste,
    ORDEM_NIVEIS,
} from './niveis-agrupamento'

export const adaptadorAjustes: AdaptadorAgrupamentoRelatorio<
    NivelAjuste,
    Ajuste,
    LinhaExplodidaAjuste
> = {
    niveisValidos: ORDEM_NIVEIS,
    ordemNiveis: ORDEM_NIVEIS,
    labelNivel: LABEL_NIVEL,
    campoPorNivel: CAMPO_POR_NIVEL,
    obterGroupingModel: (niveisAtivos: Set<NivelAjuste>) =>
        derivarGroupingModel(niveisAtivos, ORDEM_NIVEIS, CAMPO_POR_NIVEL),
    podeExpandirLinha: podeExpandirGrupoTerminal,
    explodirLinhas,
}
